import useAuth from '../../auth/authContext';
import { instagramConfig } from '../../commons/config';

export const useIsInstagramEnabled = () => {
  const {
    state: { user },
  } = useAuth();
  const isInstagramEnabled =
    instagramConfig.enabled &&
    !!user &&
    (instagramConfig.restrictedDomainsOnly.length === 0 ||
      !!(
        user.email &&
        instagramConfig.restrictedDomainsOnly.some((d) =>
          user.email.toLowerCase().endsWith(`@${d.toLowerCase()}`)
        )
      ));
  return { isInstagramEnabled };
};
